/* eslint-disable react-hooks/exhaustive-deps */
import { useLayoutEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./components";
import { SidebarNav, useSidebarCollapsed } from "./components/SidebarNav";
import { AutoBreadcrumb } from "./components/AutoBreadcrumb";
import { I18n } from "aws-amplify/utils";
import { translations } from "@aws-amplify/ui-react";
import { fetchAuthSession, signOut } from "aws-amplify/auth";
import { hasBackofficeRole } from "../utils/functions/backoffice-roles";
import { ProgressSpinner } from "primereact/progressspinner";

I18n.putVocabularies(translations);
I18n.setLanguage("es");

I18n.putVocabulariesForLanguage("es", {
  Username: "Correo Electrónico",
  "Please confirm your Password": "Confirme su contraseña",
  "Enter your Username": "Escriba su correo",
});

/**
 * Shell del backoffice — SYSTEM_DESIGN.md §4 / INC-07.
 *
 * Sidebar fijo a la izquierda, visible en todas las pantallas, y área de
 * trabajo que compensa con margin-left. Antes el sidebar era un overlay que
 * vivía dentro del Header y arrancaba cerrado.
 */
const PageLayout = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { collapsed, toggle } = useSidebarCollapsed();

  async function currentSession() {
    try {
      const session = await fetchAuthSession();
      const sessionRole =
        (session?.tokens?.accessToken?.payload["cognito:groups"] as Array<string>) || [];
      const accessToken = session.tokens?.accessToken?.toString() ?? "";
      const idToken = session.tokens?.idToken?.toString() ?? "";
      if (!accessToken || !idToken || !hasBackofficeRole(sessionRole)) {
        signOut();
      }
    } catch (err) {
      console.error("Error fetching session: ", err);
      return { accessToken: "", idToken: "", loginId: "", sessionRole: [] };
    }
  }

  useLayoutEffect(() => {
    async function loadSession() {
      setIsLoading(true);
      await currentSession();
      setIsLoading(false);
    }
    loadSession();
  }, []);

  return (
    <div className="surface-200 min-h-screen">
      {/* El header cruza todo el ancho y el sidebar cuelga de él, como en el
          mockup. Por eso va FUERA de .main-area: adentro arrancaba a los 232px
          y la barra de marca quedaba cortada por el sidebar. */}
      <Header />

      <SidebarNav collapsed={collapsed} onToggle={toggle} />

      <div
        className={`main-area flex flex-column justify-content-between ${
          collapsed ? "main-area--collapsed" : ""
        }`}
      >
        <main className="flex flex-column p-3">
          {/* BO-NAV-03 — entre el header y el contenido, nunca dentro de una
              card. Solo aparece en las pantallas que están en el menú; las que
              no, ponen su propio breadcrumb con el nombre de la entidad. */}
          <AutoBreadcrumb />
          {isLoading ? (
            <div className="flex w-full justify-content-center align-items-center">
              <ProgressSpinner />
            </div>
          ) : (
            <Outlet />
          )}
        </main>
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export default PageLayout;
